const Data = {
  instructor: [
    {
      id: 1,
      name: 'Solomon Izuking',
      course: 'FullStack & Mobile',
    },
    {
      id: 2,
      name: 'Valentine MrVal042',
      course: 'FrontEnd',
    },
    {
      id: 3,
      name: 'Innocent Memo',
      course: 'BackEnd',
    },
    {
      id: 3,
      name: 'Ogiliga Don',
      course: 'UI/UX Design',
    },
  ],

  subjects: [
    {
      id: 1,
      name: 'UI/UX design',
      course: [{ name: 'HTML' }],
      outlines: ['Adope', 'Droper', 'Atom', 'Photo Editor'],
      duration: '12 Weeks',
      students: 2,
    },
    {
      id: 2,
      name: 'FrontEnd Dev.',
      outlines: ['HTML', 'CSS', 'JS', 'REACTJS'],
      duration: '24 Weeks',
      students: 10,
    },
    {
      id: 3,
      name: 'BackEnd Dev.',
      outlines: ['JS', 'NodeJs', 'Php', 'Mongo DB'],
      duration: '18 Weeks',
      students: 2,
    },
    {
      id: 4,
      name: 'FullStack Dev.',
      outlines: ['HTML, CSS, JS', 'REACTS', 'NodeJs or Php', 'Mongo DB'],
      duration: '38 Weeks',
      students: 2,
    },
    {
      id: 5,
      name: 'Mobile Dev.',
      outlines: ['HTML, CSS , JS', 'REACTJS', 'ReactNative', 'Swift or Kotlin'],
      duration: '24 Weeks',
      students: 2,
    },
  ],

  students: [
    {
      id: 1,
      name: 'Chinonso odo',
      state: 'Abia',
      course: 'FullStack',
      status: 'ex-student',
      phone: '08032123432',
    },
    {
      id: 2,
      name: 'Valentine Coder',
      state: 'Lagos',
      course: 'FullStack',
      status: 'active-student',
      phone: '09054231223',
    },
    {
      id: 2,
      name: 'Anslem Ckika',
      state: 'Enugu',
      course: 'Mobile',
      status: 'ex-student',
      phone: '070653925687',
    },
    {
      id: 2,
      name: 'Solomon Ugwu',
      state: 'Imo',
      course: 'frontEnd',
      status: 'ex-student',
      phone: '070653925687',
    },
    {
      id: 2,
      name: 'kelvin John',
      state: 'River',
      course: 'UI/UX',
      status: 'ex-student',
      phone: '070653925687',
    },
  ],
  social: {
    facebook: 'https://web.facebook.com/profile.php?id=100070609338750',
    github: '',
    Instagram: '',
    linkeIn: '',
    twitter: '',
    whatsapp: 'https://wa.me/qr/CRRV7B262EZZG1',
  },
  projects: [
    {
      id: 1,
      class: 'ReactJs',
      name: 'Business-Venture',
      image: './img/bv_site.jpeg',
      description:
        'Business-venture is the basic React Project built after learning the basic reactjs. It is a one page app with a scroll link in the navbar and the footer,conditional access to social links which is disabled by default and enable once you accept the fake terms and condition. Ever Positive and Never Negative',
      source: 'https://github.com/mrval042.io/business-venture',
      link: 'https://mrval042.github.io/business-venture/',
      buildBy: 'MrVal042',
      likes: 100,
    },
    {
      id: 2,
      class: 'ReactJs',
      name: 'CodeAnts',
      image: './img/codeants_main.png',
      description: `Code ants is one of my major projects, build from scratch and deployed within an interval of 15 working days, with avarage of 10 hours per day. it's responsive, well design, has a lot effects, google map and the list goes on. feel at home to explore the beautiful site.`,
      source: '/pageNotFound',
      link: 'https://mrval042.github.io/Code-Ants/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 235,
    },
    {
      id: 3,
      class: 'ReactJs',
      name: 'Izuking Class',
      image: './img/izuking_class.png',
      description:
        'Izuking class is a projects build in respect to my mentor, Boss Ogbodo Solomon Izuking, a Nigeria based Software Enginerer. The aim of this projects is to help the upcoming students or mentee on the chronological steps to achieve their career or dream as a software developer.',
      source: '/pageNotFound',
      link: '/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 152,
    },

    {
      id: 4,
      class: 'Others',
      name: 'CodeAnts',
      image: './img/codeants_site.jpeg',
      description:
        'While Learning to build amd deploying website in difference free dite builder, which i dont feel like trying again because just like game for the end user. ',
      source: '/pageNotFound',
      link: 'https://sites.google.com/view/codants/home',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 235,
    },
    {
      id: 5,
      class: 'Basic Js',
      name: 'Bg-Color changer',
      image: 'https://picsum.photos/id/7/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/background-toggler',
      link: 'https://mrval042.github.io/background-toggler/',
      createdAt: '16/11/2020',
      buildBy: 'MrVal042',
      likes: 32,
    },
    {
      id: 6,
      class: 'Basic Js',
      name: 'Todo app',
      image: 'https://picsum.photos/id/77/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/Todo%20App',
      link: 'https://mrval042.github.io/Basic-Js/Todo%20app/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 32,
    },
    {
      id: 7,
      class: 'Basic Js',
      name: 'Star lab',
      image: 'https://picsum.photos/id/777/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/star-lab',
      link: 'https://mrval042.github.io/Basic-Js/star-lab/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 32,
    },
    {
      id: 8,
      class: 'Basic Js',
      name: 'CountDown Offer',
      image: 'https://picsum.photos/id/8/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/countDonw',
      link: 'https://mrval042.github.io/Basic-Js/countDown/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 32,
    },
    {
      id: 9,
      class: 'Others',
      name: 'First Assesment',
      image: 'https://picsum.photos/id/88/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/site-assesment',
      link: 'https://mrval042.github.io/Basic-Js/site-assesment/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 32,
    },
    {
      id: 10,
      class: 'Others',
      name: 'e-commence',
      image: 'https://picsum.photos/id/888/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/e-commence',
      link: 'https://mrval042.github.io/Basic-Js/e-commence/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 32,
    },
    {
      id: 11,
      class: 'Others',
      name: 'W3c todo',
      image: 'https://picsum.photos/id/11/200/300',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius deserunt doloribus dolor ut corrupti dicta?',
      source: 'https://github.com/MrVal042/W3%20Todo%20list',
      link: 'https://mrval042.github.io/Basic-Js/W3%20Todo%20list/',
      createdAt: '16/11/2021',
      buildBy: 'MrVal042',
      likes: 32,
    },
  ],

  userPage: {
    introText: `Software Engineering is about teams and it is about quality. The problems to solve are so complex or large, that a single developer cannot solve them anymore.
      Teams do not consist only of developers, but also of quality assurance testers, systems architects, system/platform engineers, customers, project managers and other stakeholders.`,
    course: [
      {
        name: 'UI/UX designer',
        intro:
          'UX design refers to user experience design, while UI design stands for user interface design. Both of these are crucial to an IT product and need to work closely together.Despite being very integral to each other, the roles themselves are quite different, involving distinct processes.',
        outlines: [
          {
            name: 'Sketch',
            description:
              'Sketch is the home for your entire collaborative design process. From early ideas to pixel-perfect artwork, playable prototypes and developer handoff. It all starts here. sketch is pretty Good for interface design,',
            link: 'https://www.sketch.com/',
          },
          {
            name: 'Figma',
            description:
              'Figma brings your teams together to design better products from start to finish. Best for collaborative interface design',
            link: 'https://www.figma.com/',
          },
          {
            name: 'Balsamiq ',
            description: `Balsamiq is good for low fidelity wireframing. Thus,UX Professionals also use Balsamiq Wireframes because it's the fastest, most focused low-fidelity wireframing tool in the industry.`,
            link: 'https://balsamiq.com/',
          },
          {
            name: 'Adobe XD',
            description: `Design like you always imagined.
            Share your story with designs that look and feel like the real thing. Wireframe, animate, prototype, collaborate, and more — it’s all right here, all in one UI/UX design tool. Adobe XD is for interface design and prototyping`,
            link: 'https://www.adobe.com/products/xd.html',
          },
          {
            name: 'Marvel App',
            description:
              'Marvel has everything you need to bring ideas to life and transform how you create digital products with your team. Placing the power of design in everyone’s hands. Marvel, for making mockups interactive',
            link: 'https://marvelapp.com/',
          },
          {
            name: 'Invision App',
            description:
              'Design Better. Faster. Together.The digital product design platform powering the world’s best user experiences. Invision App, for prototyping and collaboration',
            link: 'https://www.invisionapp.com/',
          },
        ],
      },
      {
        name: 'FrontEnd Developer',
        intro:
          'Front-end web development, also known as client-side development is the practice of producing HTML, CSS and JavaScript for a website or Web Application so that a user can see and interact with them directly. The challenge associated with front end development is that the tools and techniques used to create the front end of a website change constantly and so the developer needs to constantly be aware of how the field is developing.',
        outlines: [
          {
            name: 'Internet',
            description: `The Internet is a global network of billions of computers and other electronic devices. With the Internet, it's possible to access almost any information, communicate with anyone else in the world, and do much more.`,
            link: 'https://edu.gcfglobal.org/en/internetbasics/what-is-the-internet/1/',
          },
          {
            name: 'HTML',
            description: `HyperText Markup Language (HTML) is the most basic building block of the Web. It defines the meaning and structure of web content. Other technologies besides HTML are generally used to describe a web page's appearance/presentation (CSS) or functionality/behavior (JavaScript).`,
            link: 'https://developer.mozilla.org/en-US/docs/Web/HTML',
          },
          {
            name: 'CSS',
            description:
              'Cascading Style Sheets (CSS) is a stylesheet language used to describe the presentation of a document written in HTML or XML (including XML dialects such as SVG, MathML or XHTML).',
            link: 'https://developer.mozilla.org/en-US/docs/Web/CSS',
          },
          {
            name: 'JS',
            description:
              'JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions. While it is most well-known as the scripting language for Web pages, many non-browser environments also use it, such as Node.js, Apache CouchDB and Adobe Acrobat.',
            link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
          },
          {
            name: 'React',
            description:
              'React is a JavaScript library for building user interfaces. React makes it painless to create interactive UIs. Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.',
            link: 'https://reactjs.org/tutorial/tutorial.html#wrapping-up',
          },
          {
            name: 'GiT',
            description:
              'Git is a free and open source distributed version control system designed to handle everything from small to very large projects with speed and efficiency.',
            link: 'https://git-scm.com/',
          },
          {
            name: 'Github',
            description:
              ' GitHub is where over 65 million developers and companies build, ship,  maintain their software, shape of the future of software together​. Contribute to the open source community and manage their Git repositories.GitHub is the largest and most ReactJsd development platform in the world.',
            link: 'https://github.com/',
          },
        ],
      },
      {
        name: 'BackEnd developer',
        intro:
          'Back-end developers are responsible for and focus on the inner workings of web applications to build out the "server-side" of web applications. Server-side is the code and language that runs behind the scenes on the web server or the back-end.Back-end developers work hand-in-hand with front-end developers by providing the outward facing web application elements server-side logic. ',
        outlines: [
          {
            name: 'Basic frontEnd',
            description: `Understanding the basic front-end web technologies like HTML, CSS, and JavaScript (to communicate with team members on the front-end).`,
            link: 'https://developer.mozilla.org/en-US/docs/Learn/Front-end_web_developer',
          },
          {
            name: 'Sever-Side',
            description: `Welcome to the MDN beginner's server-side programming course! In this first article, we look at server-side programming from a high level, answering questions such as "what is it?", "how does it differ from client-side programming?", and "why it is so useful?". After reading this article you'll understand the additional power available to websites through server-side coding.Takea course and master the Sever-Side Scripts Developing`,
            link: 'https://developer.mozilla.org/en-US/docs/Learn/Server-side/First_steps/Introduction',
          },
          {
            name: 'Database',
            description: `Learn the basics of database management systems, and why they're a step up from spreadsheets when it comes to data storage and retrieval.
            Takea course and master difference Database Developing,`,
            link: 'https://www.quackit.com/database/tutorial/',
          },
          {
            name: 'security ',
            description: `Manage third-party apps & services with access to your account.
                To help you safely share your data, Google lets you give third-party apps and services access to different parts of your Google Account. Third-party apps and services are created by companies or developers that aren’t Google.Takea course and master app accessility and security Developing`,
            link: 'https://support.google.com/accounts/answer/3466521?hl=en',
          },
        ],
      },
      {
        name: 'Fullstack developer',
        intro:
          'A full stack developer is an engineer who can handle all the work of databases, servers, systems engineering, and clients. You need to be proficient in multiple programming languages, such as Javascript, JAVA, PHP, C #, Python, Ruby, Perl, etc. As most of your core business processes need to be written in these languages.Maybe not all need. But you also have to master the language grammar, and to be very familiar with how to structure, design, implementation, and testing of the project based on one language or more languages. ',
        outlines: [
          {
            name: 'FrontEnd',
            description: `Welcome to our front-end web developer learning pathway!
            Here we provide you with a structured course that will teach you all you need to know to become a front-end web developer. Work through each section, learning new skills (or improving existing ones) as you go along. Each section includes exercises and assessments to test your understanding before you move forward.
            Takea course and master the FrontEnd Developing .`,
            link: 'https://developer.mozilla.org/en-US/docs/Learn/Front-end_web_developer',
          },
          {
            name: 'BackEnd',
            description: `Back-end Development refers to the server-side development. It focuses on databases, scripting, website architecture. It contains behind-the-scene activities that occur when performing any action on a website. It can be an account login or making a purchase from an online store. Code written by back-end developers helps browsers to communicate with database information.Take a course and master the BackEnd Developing`,
            link: 'https://www.guru99.com/what-is-backend-developer.html',
          },
          {
            name: 'Sever-Side',
            description: `Welcome to the MDN beginner's server-side programming course! In this first article, we look at server-side programming from a high level, answering questions such as "what is it?", "how does it differ from client-side programming?", and "why it is so useful?". After reading this article you'll understand the additional power available to websites through server-side coding.Takea course and master the Sever-Side Scripts Developing`,
            link: 'https://developer.mozilla.org/en-US/docs/Learn/Server-side/First_steps/Introduction',
          },
          {
            name: 'Database',
            description: `Learn the basics of database management systems, and why they're a step up from spreadsheets when it comes to data storage and retrieval.
            Takea course and master difference Database Developing,`,
            link: 'https://www.quackit.com/database/tutorial/',
          },
          {
            name: 'security ',
            description: `Manage third-party apps & services with access to your account.
                To help you safely share your data, Google lets you give third-party apps and services access to different parts of your Google Account. Third-party apps and services are created by companies or developers that aren’t Google.Takea course and master app accessility and security Developing`,
            link: 'https://support.google.com/accounts/answer/3466521?hl=en',
          },
        ],
      },
      {
        name: 'Mobile developer',
        intro:
          'A Mobile Developer – also known as a mobile app developer or an app developer – is someone who designs, develops, and implements mobile applications. They are responsible for the development of these software applications in line with the appropriate mobile platforms. ',
        outlines: [
          {
            name: 'HTML',
            description: `HTML is the standard markup language for Web pages.
            With HTML you can create your own Website. HTML is easy to learn - You will enjoy it!. Take a Html course on W3Schools and master the html.`,
            link: 'https://www.w3schools.com/html/default.asp',
          },
          {
            name: 'CSS',
            description: `CSS is the language we use to style an HTML document. 
            CSS describes how HTML elements should be displayed. This tutorial will teach you CSS from basic to ReactJsd.Take a course and master the css.`,
            link: 'https://www.w3schools.com/css/default.asp',
          },
          {
            name: 'JAVASCRIPT',
            description: `JavaScript is the world's most popular programming language. JavaScript is the programming language of the Web. JavaScript is easy to learn. This tutorial will teach you JavaScript from basic to ReactJsd. Takea course and master the javascripts`,
            link: 'https://www.w3schools.com/js/default.asp',
          },
          {
            name: 'Basic Reactjs ',
            description: `React is a JavaScript library for building user interfaces. Learn what React is all about on our homepage or in the tutorial. React has been designed from the start for gradual adoption, and you can use as little or as much React as you need. Whether you want to get a taste of React, add some interactivity to a simple HTML page, or start a complex React-powered app, the links in this section will help you get started.
            Takea course and master the basic React concepts, like JSX, components, state, and props. `,
            link: 'https://reactjs.org/tutorial/tutorial.html',
          },
          {
            name: 'ReactNative',
            description: `React Native is like React, but it uses native components instead of web components as building blocks. So to understand the basic structure of a React Native app, you need to understand some of the basic React concepts, like JSX, components, state, and props. If you already know React, you still need to learn some React-Native-specific stuff, like the native components. This tutorial is aimed at all audiences, whether you have React experience or not.Takea course and master difference Database Developing`,
            link: 'https://reactnative.dev/docs/tutorial',
          },
        ],
      },
    ],
  },

  certificate: [
    'O level',
    'OND',
    'HND',
    'Diploma',
    'Degree',
    "P'hD",
    'Technician',
    'Certificate of Completion',
  ],

  state: [
    'Abia',
    'Adamawa',
    'Akwa - Ibom',
    'Anambra',
    'Bauchi',
    'Bayelsa',
    'Benue',
    'Borno',
    'Cross - River',
    'Delta',
    'Ebonyi',
    'Edo',
    'Ekiti',
    'Enugu',
    'Gombe',
    'Imo',
    'Jigawa',
    'Kaduna',
    'Kano',
    'KatsinA',
    'Kebbi',
    'Kogi',
    'Kwara',
    'Lagos',
    'Nasarawa',
    'Niger',
    'Ogun',
    'Ondo',
    'Osun',
    'Oyo',
    'Plateau',
    'Rivers',
    'Sokoto',
    'Taraba',
    'Yobe',
    'Zamfara',
    'FCT',
  ],

  nation: [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    "Côte d'Ivoire",
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    "Congo' (Congo-Brazzaville)",
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czechia (Czech Republic)',
    'Democratic Republic of the Congo',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini (fmr. "Swaziland")',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Holy See',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar (formerly Burma)',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Korea',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine State',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Korea',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States of America',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ],
}

export default Data
